import { useState } from 'react';

export function useWarnings() {
  const [warnings, setWarnings] = useState({});

  function patchWarnings(key, value) {
    setWarnings({
      ...warnings,
      [key]: value,
    });
  }

  return [warnings, patchWarnings];
}
